module.exports = __webpack_public_path__ + "static/img/case3.33cda074.png";